import { useContext } from "react";
import { Box } from "@mui/material";
import Sidebar from "../global/Sidebar";
import { FiltersContext } from "../store/filters-options-context";
import HeaderFixed from "./indicator/FixedHeader";
import AllIndicators from "./BulkList";
import { useFlatIndicators } from '../utils/indicatorsrList';
import Footer from "./Footer";
import { BulkProvider } from "../store/bulklist-filters-context";

// Route is ":type/:countryId/:years" (App.js). This page previously read
// useParams().section - a param this route doesn't define, so it was always
// undefined - and never read "years" at all. countryId/years are consumed
// centrally instead: BulkProvider reads countryId itself (bulklist-filters-context.jsx),
// and FiltersProvider hydrates params.year from the URL (getYearsFromUrl), the
// same mechanism the indicators route uses.
export default function BulkDownload(props) {
    const { valueSelected, yearRange, params, setParams } = useContext(FiltersContext);
    const flatIndicators = useFlatIndicators();


    return (
        <BulkProvider>
            <Box display="flex" flexDirection="row" className="container">
                <Sidebar />
                <Box
                    display="flex"
                    flexDirection="column"
                    className="right-column"
                >
                    <HeaderFixed
                        country={valueSelected.area}
                        params={params}
                        setParams={setParams}
                        yearRange={yearRange} />
                    <Box
                        id="scroll-content"
                        sx={{
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            backgroundColor: "secondary.main",
                        }}
                    >
                        <Box>
                            <AllIndicators list={flatIndicators} />
                        </Box>
                        <Footer />
                    </Box>
                </Box>
            </Box>
        </BulkProvider>
    );
}

